import Popover from '@mui/material/Popover';
import type { TAvailableTag } from '@onesource/schemas';
import { useState, type MouseEvent } from 'react';
import { MdOutlineLocalOffer } from 'react-icons/md';

import { FormSelectTrigger } from './form-select-trigger';
import { TAG_PICKER_PAPER_SX, TagPickerPanel } from './tag-picker-panel';

interface PostTagSelectorProps {
  options: TAvailableTag[];
  value: TAvailableTag[];
  onChange: (tags: TAvailableTag[]) => void;
  loading?: boolean;
}

/**
 * Multi-select tag picker for the post composer / edit form. Same trigger +
 * panel pattern as the feed's tag filter (the panel is shared). The picked
 * tags are shown outside the input by the parent composer, not as chips
 * inside the field.
 */
export const PostTagSelector = ({ options, value, onChange, loading = false }: PostTagSelectorProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  return (
    <>
      {/* The trigger stays neutral — the parent renders the selected tags as
          chips outside the field. */}
      <FormSelectTrigger
        startIcon={<MdOutlineLocalOffer size={15} />}
        onClick={(e: MouseEvent<HTMLButtonElement>) => setAnchorEl(e.currentTarget)}
      >
        Tags
      </FormSelectTrigger>
      <Popover
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        slotProps={{ paper: { sx: TAG_PICKER_PAPER_SX } }}
      >
        <TagPickerPanel title="Tag your post" options={options} value={value} onChange={onChange} loading={loading} />
      </Popover>
    </>
  );
};
